// Specific exports below in order to exclude `MFEContextData` from being included in the bundle
export { useMFEDataContext } from './mfe-data-context';
export * from './mfe-metadata-context';
